import {Component, Input, OnInit} from '@angular/core';
import {NavigationItemInterface} from '../../navigation';
import {animate, style, transition, trigger} from '@angular/animations';
import {EbmsVeeyaaConfig} from '../../../../../../app-config';

@Component({
  selector: 'app-nav-collapse',
  templateUrl: './nav-collapse.component.html',
  styleUrls: ['./nav-collapse.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)', display: 'block'}),
        animate('250ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('250ms ease-in', style({transform: 'translateY(-100%)'}))
      ])
    ])
  ],
})
export class NavCollapseComponent implements OnInit {
  public visible;
  @Input() item: NavigationItemInterface;
  @Input() isNested: boolean = false;
  public nextConfig: any;
  public themeLayout: string;
  public isLevel3: boolean = false;
  public isLevel2: boolean = false;

  constructor() {
    this.visible = false;
    this.nextConfig = EbmsVeeyaaConfig.config;
    this.themeLayout = this.nextConfig.layout;
  }

  ngOnInit() {
    // If explicitly marked as nested, we know it's level 2
    if (this.isNested) {
      this.isLevel2 = true;
      this.isLevel3 = false;
      
      setTimeout(() => {
        const element = document.querySelector(`[data-menu-id="${this.item.id}"]`);
        if (element) {
          element.classList.add('pcoded-nested-collapse');
          element.classList.add('level-2');
          
          // Check if parent is also nested (making this level 3)
          const parentSubmenu = element.closest('.pcoded-submenu');
          if (parentSubmenu) {
            const parentHasMenu = parentSubmenu.closest('li.pcoded-hasmenu');
            if (parentHasMenu && parentHasMenu.classList && parentHasMenu.classList.contains('pcoded-nested-collapse')) {
              this.isLevel3 = true;
              this.isLevel2 = false;
              element.classList.remove('level-2');
              element.classList.add('level-3');
            }
          }
        }
      }, 50);
    } else {
      // Auto-detect if this is a nested collapse (inside another submenu) if not explicitly set
      setTimeout(() => {
        const element = document.querySelector(`[data-menu-id="${this.item.id}"]`);
        if (element) {
          const parentSubmenu = element.closest('.pcoded-submenu');
          const ownSubmenu = element.querySelector('.pcoded-submenu');
          const isActuallyNested = parentSubmenu !== null && parentSubmenu !== ownSubmenu;
          
          if (isActuallyNested) {
            this.isNested = true;
            this.isLevel2 = true;
            element.classList.add('pcoded-nested-collapse');
            element.classList.add('level-2');
            
            // Check if parent is also nested (making this level 3)
            const parentHasMenu = parentSubmenu && parentSubmenu.closest('li.pcoded-hasmenu');
            if (parentHasMenu && parentHasMenu.classList && parentHasMenu.classList.contains('pcoded-nested-collapse')) {
              this.isLevel3 = true;
              this.isLevel2 = false;
              element.classList.remove('level-2');
              element.classList.add('level-3');
            }
          }
        }
      }, 50);
    }
  }

  isExpanded(): boolean {
    if (typeof document === 'undefined') {
      return this.visible;
    }
    const element = document.querySelector(`[data-menu-id="${this.item.id}"]`);
    return element ? element.classList.contains('pcoded-trigger') : this.visible;
  }

  navCollapse(e) {
    // Always prevent default navigation for collapse items with children
    if (this.item.children && this.item.children.length > 0) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    this.visible = !this.visible;

    // Find the correct parent element
    let parent: HTMLElement | null = null;
    const target = e.target as HTMLElement;
    
    // Try multiple ways to find the parent menu item
    if (this.themeLayout === 'vertical') {
      // First, try to find the closest pcoded-hasmenu
      parent = target.closest('li.pcoded-hasmenu') as HTMLElement;
      
      // If not found, traverse up the DOM tree
      if (!parent) {
        let current: HTMLElement | null = target.parentElement;
        while (current && !parent) {
          if (current.classList && current.classList.contains('pcoded-hasmenu')) {
            parent = current;
            break;
          }
          current = current.parentElement;
        }
      }
      
      // Fallback: find by data-menu-id
      if (!parent && this.item.id) {
        parent = document.querySelector(`li[data-menu-id="${this.item.id}"]`) as HTMLElement;
      }
    } else {
      parent = target.closest('.pcoded-hasmenu') as HTMLElement || target as HTMLElement;
    }
    
    if (!parent || !parent.classList) {
      console.warn('Parent menu element not found for:', this.item.title);
      return;
    }

    // Check if this menu item is inside a parent submenu (nested collapse)
    const parentSubmenu = parent.closest('.pcoded-submenu');
    const isNestedMenu = this.isNested || (parentSubmenu !== null);

    // Toggle current menu
    parent.classList.toggle('pcoded-trigger');

    // If it's a nested menu, ensure all parent menus stay open
    if (isNestedMenu) {
      // Find and keep all parent menus open
      let currentParent = parentSubmenu;
      while (currentParent) {
        const parentMenu = currentParent.closest('.pcoded-hasmenu');
        if (parentMenu && parentMenu !== parent) {
          parentMenu.classList.add('pcoded-trigger');
          // Move up to the next level
          const nextSubmenu = parentMenu.closest('.pcoded-submenu');
          if (nextSubmenu && nextSubmenu !== currentParent) {
            currentParent = nextSubmenu;
          } else {
            break;
          }
        } else {
          break;
        }
      }
    } else {
      // Only close other top-level menus if this is not nested
    const sections = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        // Only close if it's not the current menu and not a parent/child of current menu
        if (section !== parent && !parent.contains(section) && !section.contains(parent)) {
          const isInsideSubmenu = section.closest('.pcoded-submenu') !== null;
          // Don't close menus that are inside submenus (nested menus)
          if (!isInsideSubmenu) {
            section.classList.remove('pcoded-trigger');
      }
    }
      }
    }

    // Ensure parent menus are kept open (existing logic)
    let firstParent = parent.parentElement;
    let preParent = parent.parentElement && parent.parentElement.parentElement;
    if (firstParent && firstParent.classList.contains('pcoded-hasmenu')) {
      do {
        firstParent.classList.add('pcoded-trigger');
        const nextParent = firstParent.parentElement;
        if (nextParent && nextParent.parentElement && nextParent.parentElement.parentElement) {
          firstParent = nextParent.parentElement.parentElement;
        } else {
          break;
        }
      } while (firstParent && firstParent.classList.contains('pcoded-hasmenu'));
    } else if (preParent && preParent.classList.contains('pcoded-submenu')) {
      do {
        const parentMenu = preParent.closest('.pcoded-hasmenu');
        if (parentMenu) {
          parentMenu.classList.add('pcoded-trigger');
        }
        const nextParent = preParent.parentElement;
        const nextSubmenu = nextParent && nextParent.parentElement && nextParent.parentElement.parentElement ? nextParent.parentElement.parentElement : null;
        if (nextSubmenu && nextSubmenu.classList.contains('pcoded-submenu')) {
          preParent = nextSubmenu;
        } else {
          break;
        }
      } while (preParent && preParent.classList.contains('pcoded-submenu'));
    }
  }

  // TrackBy function for better performance and to ensure items are tracked correctly
  trackByItemId(index: number, item: NavigationItemInterface): string {
    return item.id || index.toString();
  }

}
